import axios from 'axios';
import isPlainObject from 'lodash/isPlainObject';

import history from '../router/history';
import ROUTES from '../router/routes';

const instance = axios.create({
  baseURL: process.env.SITE_URL || 'http://localhost:3000/',
  headers: {
    'Cache-Control': 'no-cache',
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  timeout: 1000 * 10,
  responseType: 'json',
  responseEncoding: 'utf8',
  validateStatus: (status) => status >= 200 && status < 300,
  decompress: true,
});

instance.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem('accessToken');
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

instance.interceptors.response.use(
  (response) => {
    const { data } = response;
    if (isPlainObject(data) && Object.prototype.hasOwnProperty.call(data, 'accessToken')) {
      localStorage.setItem('accessToken', data.accessToken);
    }

    return response;
  },
  (error) => {
    const UNAUTHORIZED_HTTP_RES_STATUS_CODE = 401;
    if (error.response?.status === UNAUTHORIZED_HTTP_RES_STATUS_CODE) {
      localStorage.removeItem('accessToken');
      history.push(ROUTES.login);
      history.go(0);
    }

    return Promise.reject(error);
  },
);

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    const { status } = error.response || { status: 0 };
    const isRedirect = status >= 300 && status < 400;
    if (
      isRedirect
      && isPlainObject(error.response?.data)
      && Object.prototype.hasOwnProperty.call(error.response.data, 'redirect')
    ) {
      history.push(error.response.data.redirect);
      history.go(0);
    }

    return Promise.reject(error);
  },
);

export default instance;
